
import {
    ADD_PROSPECT_APPLICANT,
    ADD_PROSPECT_APPLICANT_SUCCESS,
    ADD_PROSPECT_APPLICANT_ERROR,
    UPDATE_PROSPECT_APPLICANT,
    UPDATE_PROSPECT_APPLICANT_SUCCESS,
    UPDATE_PROSPECT_APPLICANT_ERROR,
    DELETE_PROSPECT_APPLICANT,
    DELETE_PROSPECT_APPLICANT_SUCCESS,
    DELETE_PROSPECT_APPLICANT_ERROR,

} from "./actionTypes"
// addLeadApplicant
export const addProspectApplicant = payload => {
    return {
        type: ADD_PROSPECT_APPLICANT,
        payload: payload,
    }
}

// addLeadApplicantSuccess
export const addProspectApplicantSuccess = lead => {
    return {
        type: ADD_PROSPECT_APPLICANT_SUCCESS,
        payload: lead,
    }
}

// addLeadApplicantError
export const addProspectApplicantError = error => {
    return {
        type: ADD_PROSPECT_APPLICANT_ERROR,
        payload: error,
    }
}

// updateLeadApplicant
export const updateProspectApplicant = payload => {
    return {
        type: UPDATE_PROSPECT_APPLICANT,
        payload: payload,
    }
}

// updateLeadApplicantSuccess
export const updateProspectApplicantSuccess = lead => {
    return {
        type: UPDATE_PROSPECT_APPLICANT_SUCCESS,
        payload: lead,
    }
}

// updateLeadApplicantError
export const updateProspectApplicantError = error => {
    return {
        type: UPDATE_PROSPECT_APPLICANT_ERROR,
        payload: error,
    }
}

// deleteLeadApplicant
export const deleteProspectApplicant = payload => {
    return {
        type: DELETE_PROSPECT_APPLICANT,
        payload: payload,
    }
}

// deleteLeadApplicantSuccess
export const deleteProspectApplicantSuccess = lead => {
    return {
        type: DELETE_PROSPECT_APPLICANT_SUCCESS,
        payload: lead,
    }
}

// deleteLeadApplicantError
export const deleteProspectApplicantError = error => {
    return {
        type: DELETE_PROSPECT_APPLICANT_ERROR,
        payload: error,
    }
}